<template>
  <div class="container-fluid mt--7">
    <div class="row">
      <div class="col">
        <div class="card mb-3">
          <div class="row no-gutters">
            <div class="col-3" style="border-right: 1px solid #e0e0e0">
              <div class="card-body">
                <slot name="filterBar"></slot>
              </div>
            </div>

            <div class="col-9">
              <div class="card-body">
                <slot name="pageTable"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageContent'
};
</script>
